module.exports = __webpack_public_path__ + "static/media/tooltip wheelchair icon.b588f307.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/tooltip wheelchair icon.svg
// module id = 857
// module chunks = 0